function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowMarker3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1.001 -0.899 51.296 74.63",
    fill: "#E74B4B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.767 0C11.095.015.015 10.883 0 24.294c0 10.66 15.48 36.518 22.129 47.144.563.898 1.562 1.445 2.638 1.445 1.077.005 2.078-.545 2.637-1.448 6.65-10.62 22.129-36.47 22.129-47.14C49.518 10.882 38.438.014 24.767 0z",
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(255, 255, 0)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Arial, sans-serif",
      fontSize: 48,
      paintOrder: "fill",
      stroke: "rgb(6, 6, 6)",
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.652,
    y: 43.486,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, "3")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowMarker3);
export default __webpack_public_path__ + "static/media/yellow-marker-3.35ff152ae33a04cae65d32c156a1018c.svg";
export { ForwardRef as ReactComponent };